<template>
  <!--角色管理 -->
  <div class="newsPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>公司名称：</div>
          <el-input clearable placeholder="请输入公司名称" size="small" style="width: 180px;margin-right: 10px"
                    v-model="companyName"></el-input>
          <div>产品名称：</div>
          <el-input clearable placeholder="请输入产品名称" size="small" style="width: 180px;margin-right: 10px"
                    v-model="companyExplain"></el-input>
          <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button size="small" type="success" @click="addBtn">新增</el-button>
          <el-button size="small" type="success" @click="backBtn">返回上一页</el-button>
        </div>

        <el-table
            size="small"
            tooltip-effect="dark"
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column
            align="center"
            label="公司编号"
            prop="player_no"
        />
          <el-table-column
              align="center"
              label="公司名称"
              prop="company_name"
          />
          <el-table-column label="产品名称" width="230" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.company_explain}}
                </template>
                <span style="width:210px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.company_explain }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="栏目一"
              prop="one_name"
          />
          <el-table-column
              align="center"
              label="栏目二"
              prop="two_name"
          />
          <el-table-column
              align="center"
              label="当前票数"
              prop="vote_number"
          />
          <el-table-column
              align="center"
              label="栏目三"
              prop="three_name"
          />
          <el-table-column label="产品介绍" width="230" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.introduce}}
                </template>
                <span style="width:210px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.introduce }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="活动类型"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.vote_type === 1 ? '图片' : '视频' }}</div>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="图片或视频"
              width="150"
          >
            <template slot-scope="scope">
              <el-image v-if="scope.row.vote_type === 1" :preview-src-list="scope.row.img_urlList" :src="scope.row.img_url"/>
              <el-button v-else type="primary" size="mini" @click="viewVideoBtn(scope.row)">播放</el-button>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="240"
          >
            <template slot-scope="scope">
              <el-button @click="editNumberBtn(scope.row)"
                         size="small"
                         type="success">修改票数
              </el-button>
              <el-button @click="editBtn(scope.row)"
                         size="small"
                         type="success">修改
              </el-button>
              <el-button style="margin-top: 10px" @click="deleteBtn(scope.row)" size="small" type="danger">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>

    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="1000px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item v-if="ruleForm.voteType === 1" label="图片" prop="imgUrl">
              <el-upload
                  :before-upload="imgUrlBeforeAvatarUpload"
                  :on-success="imgUrlHandleAvatarSuccess"
                  :show-file-list="false"
                  :action="uploadApiUrl"
                  class="coverClass cover-uploader">
                <img v-if="ruleForm.imgUrl" :src="ruleForm.imgUrl" class="cover">
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="ruleForm.voteType === 2" label="视频" prop="imgUrl">
              <div style="position: relative">
                <el-upload
                    class="upload-demo"
                    :action="uploadVideoUrl"
                    :on-success="videoUploadSuccess"
                    :on-remove="videoUploadRemove"
                    :before-upload="videoBeforeUpload"
                    :file-list="videoData"
                    :show-file-list="false"
                    :limit="1">
                  <el-button style="position: absolute;left: 0;top:4px;" size="small" type="primary">点击上传</el-button>

                  <div v-if="videoIsSuccessed !== null" style="display: flex;margin-top: 30px">
                    <div>{{ videoName }}</div>
                    <div style="margin: 0 10px" :style="videoIsSuccessed ? 'color: green' : 'color: red'">{{videoIsSuccessed ? '上传完成': '上传中'}}</div>
                    <div style="color:cornflowerblue;" @click="clearBtn">重新选择文件</div>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="产品名称" prop="companyExplain">
              <el-input v-model="ruleForm.companyExplain" style="width: 100%" size="small"
                        placeholder="请输入产品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="公司编号" prop="playerNo">
              <el-input-number
                  v-model="ruleForm.playerNo"
                  :step="1"
                  :min="0"
                  size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="ruleForm.companyName" style="width: 100%" size="small" placeholder="请输入公司名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="活动类型" prop="voteType">
              <el-select v-model="ruleForm.voteType" @change="typeChange" placeholder="请选择" size="small" style="width: 100%">
                <el-option
                    v-for="item in [{'key':1,'value':'图片'},{'key':2,'value':'视频'}]"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="栏目一" prop="oneName">
              <el-input v-model="ruleForm.oneName" style="width: 100%" size="small" placeholder="请输入栏目一名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="栏目二" prop="twoName">
              <el-input v-model="ruleForm.twoName" style="width: 100%" size="small" placeholder="请输入栏目二名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="栏目三" prop="threeName">
              <el-input v-model="ruleForm.threeName" style="width: 100%" size="small" placeholder="请输入栏目三名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="产品介绍" prop="introduce">
              <el-input type="textarea" v-model="ruleForm.introduce" style="width: 100%" size="small"
                        placeholder="请输入产品介绍"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </a-modal>

    <a-modal
        :visible="changeDialogState"
        cancel-text="取消"
        ok-text="确认"
        title="修改投票数"
        width="400px"
        @cancel="changeCancel"
        @ok="changeSubmit('ruleForm')"
    >
      <el-form
          ref="changeForm"
          :model="changeForm"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="当前票数">
          <el-input v-model="changeForm.voteNumber" style="width: 100%" size="small" placeholder="请输入栏目三名称"></el-input>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{ simpleDelete ? '是否删除该条记录？' : '是否删除当前所选中的记录？' }}</div>
    </a-modal>

    <a-modal
        :visible="videoDialogState"
        title="视频"
        width="1200px"
        @cancel="videoDialogCancel"
    >
      <template slot="footer">
        <a-button key="back" v-show="false">
          Return
        </a-button>
        <a-button @click="videoDialogCancel" key="submit" v-show="true">
          关闭
        </a-button>
      </template>
      <video-player class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
      </video-player>
    </a-modal>
  </div>
</template>
<script>
import {baseURL} from "@/api/config";
export default {
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  data() {
    return {
      id:null,
      dialogTitle: '',
      pageNum: 1,
      pageSize: 20,
      examineStatus: null,
      menu: null,
      companyName: '',
      companyExplain: '',
      tableData: [],
      totalElements: 0,//数据总数
      addDialogState: false,
      videoData: [],
      ruleForm: {
        id: null,
        handVoteId: this.id,
        oneName: "", //栏目1名称
        twoName: "", //栏目2名称
        threeName: "", //栏目3名称
        playerNo: null, //公司编号
        companyExplain: "", //产品名称
        companyName: "", //公司名称
        imgUrl: '', //公司介绍图、视频url
        introduce: "", //产品介绍
        voteType: null //活动类型 1图片 2视频
      },
      rules: {
        imgUrl: [{required: true, message: "请上传公司介绍图或者视频", trigger: "blur"}],
        oneName: [{required: true, message: "请输入栏目一名称", trigger: "blur"}],
        twoName: [{required: true, message: "请输入栏目二名称", trigger: "blur"}],
        threeName: [{required: true, message: "请输入栏目三名称", trigger: "blur"}],
        playerNo: [{required: true, message: "请输入公司编号", trigger: "blur"}],
        companyName: [{required: true, message: "请输入公司名称", trigger: "blur"}],
        companyExplain: [{required: true, message: "请输入产品名称", trigger: "blur"}],
        introduce: [{required: true, message: "请输入产品介绍", trigger: "blur"}],
        voteType: [{required: true, message: "请选择活动类型", trigger: "blur"}],
      },
      uploadApiUrl: '',
      uploadVideoUrl: '',
      simpleDelete: false,
      deleteId: null,
      deleteDialogState: false,
      multipleSelection: [],
      currentId: null,
      currentMenu: null,
      newsIsHave: [],
      newsAllHave: [],
      dialogcompanyName: '',
      dialogPage: 1,
      dialogSize: 5,
      dialogTotal: 0,
      videoDialogState: false,
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: 'auto',
        language: 'zh-CN',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: '16:9',
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [{
          //类型
          type: "video/mp4",
          //url地址
          src: ''
        }],
        //你的封面地址
        poster: '',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      },
      videoName: null,
      videoIsSuccessed: null,
      changeForm:{
        id:null,
        voteNumber: null
      },
      changeDialogState: false
    };
  },
  mounted() {

  },
  methods: {
    viewVideoBtn(row) {
      this.playerOptions.sources[0].src = row.img_url
      this.videoDialogState = true
    },
    videoDialogCancel() {
      this.player.pause()
      this.videoDialogState = false
    },
    typeChange(){
      this.ruleForm.imgUrl = ''
      this.videoData = []
      this.videoName = null
      this.videoIsSuccessed = null
    },
    videoUploadSuccess(res) {
      if (res.success) {
        this.videoIsSuccessed = true
        this.ruleForm.imgUrl = res.entity
      }else{
        this.videoIsSuccessed = false
      }
    },
    videoUploadRemove() {
      this.videoIsSuccessed = null
      this.videoName = null
      this.ruleForm.imgUrl = ''
      this.videoData = []
    },
    videoBeforeUpload(file){
      console.log(file,999)
      this.videoName = file.name
      this.videoIsSuccessed = false
    },
    clearBtn(){
      this.videoIsSuccessed = null
      this.videoName = null
      this.ruleForm.imgUrl = ''
      this.videoData = []
    },
    searchBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.getNewsList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.examineStatus = null
      this.menu = null
      this.companyName = ''
      this.companyExplain = ''
      this.getNewsList()
    },
    backBtn(){
      this.$router.back();
    },
    addBtn() {
      this.dialogTitle = '新增'
      this.ruleForm = {
        id: null,
        handVoteId: this.id,
        oneName: "", //栏目1名称
        twoName: "", //栏目2名称
        threeName: "", //栏目3名称
        playerNo: null, //公司编号
        companyExplain: "", //产品名称
        companyName: "", //公司名称
        imgUrl: "", //公司介绍图、视频url
        introduce: "", //产品介绍
        voteType: null //活动类型 1图片 2视频
      }
      this.addDialogState = true
    },
    editNumberBtn(row){
      this.changeForm.id = row.id
      this.changeForm.voteNumber = row.vote_number
      this.changeDialogState = true
    },
    editBtn(row) {
      this.dialogTitle = '修改'
      this.ruleForm.id = row.id
      this.ruleForm.handVoteId = null
      this.ruleForm.oneName = row.one_name
      this.ruleForm.twoName = row.two_name
      this.ruleForm.threeName = row.three_name
      this.ruleForm.playerNo = row.player_no
      this.ruleForm.companyName = row.company_name
      this.ruleForm.companyExplain = row.company_explain
      this.ruleForm.introduce = row.introduce
      this.ruleForm.voteType = row.vote_type
      this.ruleForm.imgUrl = row.img_url
      if(row.vote_type === 2){
        this.videoData = []
        this.videoData.push({url: row.img_url, name: '视频文件'})
        this.videoIsSuccessed = true
        this.videoName = '视频文件'
      }
      this.addDialogState = true
    },
    viewBtn(row) {
      this.$router.push({
        path: "/voteDetailsList", query: {
          id: row.id
        }
      });
    },
    deleteBtn(row) {
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    batchDeleteBtn() {
      this.simpleDelete = false
      this.deleteDialogState = true
    },
    deleteCancel() {
      this.deleteDialogState = false
    },
    changeCancel(){
      this.changeDialogState = false
    },
    deleteSubmit() {
      if (this.simpleDelete) {
        //单个删除
        this.postAxios("/handVote/delHandVoteDetailByIds",[this.deleteId]).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.resetBtn()
          }
        })
      }
    },
    changeSubmit(){
      if(!this.changeForm.voteNumber){
        this.changeForm.voteNumber = '0'
      }
      this.postAxios("/handVote/updHandVoteDetailById", this.changeForm).then(res => {
        if (res.success) {
          this.$message.success("修改成功!")
          this.changeDialogState = false
          this.getNewsList()
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '新增'){
            this.postAxios("/handVote/addHandVoteDerail", this.ruleForm).then(res => {
              if (res.success) {
                this.$message.success("添加成功!")
                this.addDialogState = false
                this.getNewsList()
              }
            });
          }else if(this.dialogTitle === '修改'){
            this.postAxios("/handVote/updHandVoteDetailById", this.ruleForm).then(res => {
              if (res.success) {
                this.$message.success("修改成功!")
                this.addDialogState = false
                this.getNewsList()
              }
            });
          }
        }
      });
    },
    imgUrlHandleAvatarSuccess(res) {
      if (res.success) {
        this.ruleForm.imgUrl = res.entity;
      }
    },
    imgUrlBeforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    getNewsList() {
      let url = '/handVote/selHandVoteDetailByVoteId'
      this.postAxios(url, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          companyName: this.companyName,
          handVoteId: this.id,
          companyExplain: this.companyExplain
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          res.content.forEach((item)=>{
            item.img_urlList = []
            if (item.img_url){
              item.img_urlList.push(item.img_url)
            }
          })
          this.tableData = res.content;
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getNewsList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getNewsList()
    },
  },
  created() {
    this.id = this.$route.query.id
    this.uploadApiUrl = baseURL + '/file/uploadFile/v2'
    this.uploadVideoUrl = baseURL + '/file/uploadHandVoteImg'
    this.getNewsList();
  }
};
</script>
<style lang="less" scoped>

.coverClass {
  .cover-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .cover-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .cover-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    border: 1px dashed #d9d9d9;
    width: 314px;
    height: 190px;
    line-height: 190px;
    text-align: center;
  }

  .cover {
    width: 314px;
    height: 190px;
    display: block;
  }
}

.topcoverClass {
  .cover-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .cover-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .cover-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    border: 1px dashed #d9d9d9;
    width: 120px;
    height: 190px;
    line-height: 190px;
    text-align: center;
  }

  .cover {
    width: 120px;
    height: 190px;
    display: block;
  }
}

</style>
